export const PRODUCT_CATEGORY = {
    GET_ALL: '/product-category',
    CREATE: '/product-category/create',
    UPDATE: '/product-category/update',
    DELETE: '/product-category/delete',
};
